// Scripts for the layouts `users` (organizer area) and `application` (series page, account pages):
// rails-ujs, the Bootstrap 3 plugins the views use through data attributes, and small form helpers.
// Page-specific code lives in the per-page packs (users/events/form, …), which these layouts
// add with append_javascript_pack_tag.
import $ from 'jquery';
import Rails from '@rails/ujs';

// Bootstrap 3 plugins expect a global jQuery; the ProvidePlugin in config/webpack/webpack.config.js
// hands them the bundled one. transition first, the others check $.support.transition
import 'bootstrap/js/transition';
import 'bootstrap/js/alert';
import 'bootstrap/js/collapse';
import 'bootstrap/js/dropdown';
import 'bootstrap/js/modal';
import 'bootstrap/js/tooltip';

import '../organizer/forms';
import '../organizer/statistics';
import '../organizer/series_accordion';

Rails.start();

$(() => $('[data-toggle="tooltip"]').tooltip());
